import { DetailedOrderLog } from '../model/orderLog.model'
import { formatDateString } from '../utils/misc'

export const transformOrderLogs = (resources: DetailedOrderLog[]) =>
  resources.map(orderResource => ({
    ...orderResource,
    formattedLastUpdateDate: formatDateString(orderResource.updatedAt, {
      withHours: true,
    }),
  }))

export type TransformedOrderLog = ReturnType<typeof transformOrderLogs>
export type TransformedListOrderLogs = ReturnType<typeof transformOrderLogs>[0]
